import { Box, Button, Card, CardContent, Stack, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';

export function safeAuthNext(value: unknown, fallback = '/'): string {
  return typeof value === 'string' &&
    value.startsWith('/') &&
    !value.startsWith('//') &&
    !value.includes('\\') &&
    !Array.from(value).some((char) => char.charCodeAt(0) < 32)
    ? value
    : fallback;
}
export function nativeAccountHref(path: string, search: string): string {
  const query = new URLSearchParams(search);
  query.delete('spa');
  if (query.has('next')) query.set('next', safeAuthNext(query.get('next')));
  const target = new URL(path, 'http://account.local');
  query.forEach((value, name) => {
    if (!target.searchParams.has(name)) target.searchParams.set(name, value);
  });
  return target.pathname + target.search;
}
export function authReturnPath(search: string, state: unknown): string {
  const query = new URLSearchParams(search);
  if (query.has('next')) return safeAuthNext(query.get('next'));
  const from: unknown = state && typeof state === 'object' ? Reflect.get(state, 'from') : null;
  if (from && typeof from === 'object') {
    const path: unknown = Reflect.get(from, 'pathname');
    const suffix: unknown = Reflect.get(from, 'search');
    return safeAuthNext(typeof path === 'string' ? path + (typeof suffix === 'string' ? suffix : '') : null);
  }
  return '/';
}
export interface NativeAccountPanelProps {
  title: string;
  description: string;
  label: string;
  href: string;
  returnHref?: string;
  returnLabel?: string;
}
export function NativeAccountPanel({
  title,
  description,
  label,
  href,
  returnHref = '/auth/profile',
  returnLabel = 'Return to Profile',
}: NativeAccountPanelProps) {
  return (
    <Box sx={{ maxWidth: 640, mx: 'auto', p: { xs: 2, md: 3 } }}>
      <Card>
        <CardContent>
          <Stack spacing={3}>
            <Typography variant="h4" component="h1">
              {title}
            </Typography>
            <Typography>{description}</Typography>
            <Button component="a" href={href} variant="contained" sx={{ alignSelf: 'flex-start' }}>
              {label}
            </Button>
            <Button component="a" href={returnHref} variant="text" sx={{ alignSelf: 'flex-start' }}>
              {returnLabel}
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
export default function NativeAccountPage(props: NativeAccountPanelProps) {
  const location = useLocation();
  return (
    <NativeAccountPanel
      {...props}
      href={nativeAccountHref(props.href, location.search)}
      returnHref={props.returnHref ? nativeAccountHref(props.returnHref, location.search) : undefined}
    />
  );
}
